@if(text!='N/A'){<span [hidden]="!text"> {{ text | date: "dd-MMM-yyyy, hh:mm:ss a" }}</span>}
@if(text=='N/A'){<span [hidden]="!text"> {{ text }}</span>}